var _style, _desc, _g, _g2, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFuseLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:black;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16.9,
    cy: 30.2,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,33.8c-2,0-3.6-1.6-3.6-3.6s1.6-3.6,3.6-3.6s3.6,1.6,3.6,3.6S18.9,33.8,16.9,33.8z M16.9,29.5 c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6s0.6-0.3,0.6-0.6S17.3,29.5,16.9,29.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42.3,
    cy: 30.2,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.3,33.8c-2,0-3.6-1.6-3.6-3.6s1.6-3.6,3.6-3.6s3.6,1.6,3.6,3.6S44.3,33.8,42.3,33.8z M42.3,29.5 c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6s0.6-0.3,0.6-0.6S42.7,29.5,42.3,29.5z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.3,38c-4.3,0-7.9-3.5-7.9-7.9h3c0,2.7,2.2,4.9,4.9,4.9c2.7,0,4.9-2.2,4.9-4.9c0-4.3,3.5-7.9,7.9-7.9 s7.9,3.5,7.9,7.9h-3c0-2.7-2.2-4.9-4.9-4.9s-4.9,2.2-4.9,4.9C31.1,34.5,27.6,38,23.3,38z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,31.7H8.1c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.2c0.8,0,1.5,0.7,1.5,1.5S16.2,31.7,15.4,31.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.2,31.7H44c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.2c0.8,0,1.5,0.7,1.5,1.5S52,31.7,51.2,31.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFuseLight);
export default __webpack_public_path__ + "static/media/ic-fuse-light.14709d0773b8d6c9b0995b3ac3ef0e9f.svg";
export { ForwardRef as ReactComponent };